import React from 'react' // eslint-disable-line

import styled from 'styled-components'
export const PromoWrapper = styled.div`
  width: 100%;
  height: var(--promo-bar-height);
  &[data-promo-hide] {
    margin-top: calc(var(--promo-bar-height) * -1);
  }
  @media (max-width: 999px) {
    height: 0;
    &[data-promo-hide] {
      margin-top: calc(var(--promo-bar-height) * -1);
    }
  }
`
export const Promobar = styled.div`
  width: 100%;
  height: var(--promo-bar-height);
  @media (max-width: 999px) {
    height: 0;
  }
  /* ANIMATIONS */
  @-webkit-keyframes FadeInNanoBar {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-moz-keyframes FadeInNanoBar {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-o-keyframes FadeInNanoBar {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes FadeInNanoBar {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  [data-style='paragraph-wp'] {
    margin: 0; // in wordpress pages needs to override margin of p
  }

  /* PROMO NANO BAR */
  .wrapper {
    box-sizing: border-box;
    background: #000000;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: var(--promo-bar-height);
    padding: 8px 40px;

    @media (max-width: 999px) {
      --promo-bar-height: 56px;
      padding: 8px 16px;
    }

    @media (min-width: 1000px) and (max-width: 1170px) {
      --promo-bar-height: 56px;
      padding: 8px 40px;
    }

    /* ANIMATIONS - Fade In */
    /* -webkit-animation: FadeInNanoBar 1s;
    -moz-animation: FadeInNanoBar 1s;
    -o-animation FadeInNanoBar 1s;
    animation: FadeInNanoBar 1s;
    */
  }

  .wrapper {
    .layout {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 16px;
    }

    .layout promoCta {
      gap: 8px;
    }
    .tagline {
      display: flex;
      flex: 0 1 auto;
    }
    [data-section='coupon-list'] {
      display: flex;
      flex-direction: row;
      gap: 16px;

      @media (max-width: 999px) {
        gap: 0;
      }
    }
    .link {
      a {
        color: #ffffff;
        text-decoration: underline;
      }
    }

    @media (max-width: 999px) {
      .tagline {
        margin-bottom: 10px;
      }
      [data-section='coupon-list'] {
        width: 100%;
        flex-direction: column;
      }
      [data-type='item'] + [data-type='item'] {
        [data-type='item-container'] {
          border-top: none;
          border-right: 1px solid #1e1e1e;
          border-bottom: 1px solid #1e1e1e;
          border-left: 1px solid #1e1e1e;
        }
      }
    }
  }

  [data-type='countdown'] {
    [data-type='hours']:after,
    [data-type='minutes']:after {
      content: ':';
      margin: 0 5px;
    }
  }

  /* MOBILE Layout */
  .wrapper .mobile {
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: center;
    align-items: center;
  }
  .wrapper .mobile .offers-toggle {
    position: absolute;
    right: 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .wrapper .mobile .offers-toggle .caret {
    cursor: pointer;
    transition: transform 0.3s;
    transform: rotate(180deg);
    opacity: 1;
    /* global CSS overwriting opacity .hide */
  }
  .wrapper .mobile .offers-toggle .caret.show {
    transform: rotate(0deg);
  }

  /* MOBILE Styling */
  @media (min-width: 999px) {
    .wrapper .layout {
      display: flex;
    }
    .wrapper .mobile {
      display: none;
    }
  }
  @media (max-width: 999px) {
    .wrapper {
      height: var(--promo-bar-height);
      max-height: var(--promo-bar-height);
      position: relative;
      margin-top: calc(var(--promo-bar-height) * -1);
      z-index: 1000;
      /* fix for legacy mobile menu high index */
      top: 0;
      left: 0;
      flex-direction: column;
    }
    .wrapper .layout {
      position: absolute;
      top: 100%;
      right: 0;
      z-index: 10;
      gap: 0;
      flex-direction: column;
      align-items: flex-start;
      background: #ffffff;
      color: #333333;
      width: 100%;
      opacity: 0;
      transition: opacity 0.25s ease-in-out;
      -moz-transition: opacity 0.25s ease-in-out;
      -webkit-transition: opacity 0.25s ease-in-out;
      box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.1), 0 15px 15px 0 rgba(0, 0, 0, 0.1);
      pointer-events: none;
    }
    .wrapper .layout.show {
      opacity: 1;
      pointer-events: initial;
    }
    .wrapper .layout.show > * {
      color: #333333;
    }
    .wrapper .mobile {
      width: 100%;
      display: flex;
    }
  } /* BOUNCE X - CSS Targeting */
  .mobile-navigation,
  .mobile-navigation__menu__inner,
  .mobile-navigation__header,
  .checkout__header,
  .mobile-navigation__search-container {
    margin-top: var(--promo-bar-height);
  }
  @media (min-width: 999px) {
    .checkout__header {
      margin-top: 0px !important;
    }
  }
  .mobile-navigation__content {
    height: calc(100% - var(--promo-bar-height));
  }
  @media screen and (max-width: 999px) {
    form[action='/all'],
    form[action='/all'] + div,
    div[role='button'][data-reactid='15'] {
      margin-top: var(--promo-bar-height);
    }
    div[data-reactid='20'] {
      padding-top: 80px;
    }
    div[data-reactid='547'] {
      top: var(--promo-bar-height);
      z-index: 2 !important;
    }
    nav:not([data-section='main-navigation']) > div > div:first-child > div:nth-child(2),
    nav > div > form,
    nav > div > form ~ div {
      margin-top: var(--promo-bar-height) !important;
    }
    .checkout__container {
      margin-top: 120px;
    }
  }
`
export const CouponCode = styled.div`
  [data-type='info'] {
    flex-direction: column;
  }
  [data-type='apply'] {
    border-bottom: 1px solid #ffffff;

    @media (max-width: 999px) {
      border-bottom: 1px solid #000000;
    }
  }

  [data-style='paragraph-wp'] {
    margin: 0; // in wordpress pages needs to override margin of p
  }
`
